<template>
  <div :class="classSize">
    <!-- @slot The text/content to display in metadata-text style -->
    <slot />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
/**
 * Core typography component for displaying text in a metadata style
 *
 * ```
 * import xMetadataText from '@/components/shared/x-metadata-text'
 *
 * <x-metadata-text weight="medium">Lorem Ipsum</x-metadata-text>
 * ```
 *
 * @deprecated Use `<ys-text>` from the latest `@onxmaps/yellowstone-ui` release instead.
 */

export default {
  name: 'XMetadataText',
  props: {
    /**
     * Weight variant of type style
     */
    weight: {
      type: String,
      validator: function (value) {
        return ['medium', 'bold'].includes(value)
      },
      default: undefined,
    },
  },
  computed: {
    classSize() {
      return `ys-text-metadata1${this.weight ? `-${this.weight}` : ''}`
    },
  },
}
</script>
